import { apiBasic, apiGet } from "./requests";

export const getOrders = (params = "") => {
  let path = "get-orders";
  return apiGet(path, params);
};

export const getOrderDetails = (id) => {
  let path = `get-order-details/${id}`;
  return apiGet(path);
};

export const updatePreparationTimeConfig = (id, payload) => {
  let path = `update-preparation-time/${id}`;
  return apiBasic(payload, path, "patch");
};

export const updateDeliveryTimeConfig = (id, payload) => {
  let path = `update-delivery-time/${id}`;
  return apiBasic(payload, path, "patch");
};

export const getOrderManagerSalesChannel = () => {
  let path = "get-order-manager-sales-channels";
  return apiGet(path);
};

export const getOrderManagerActiveCategories = () => {
  let path = "get-order-manager-active-categories";
  return apiGet(path);
};

export const updateOrderStatus = (data = null, id) => {
  let path = `update-order-status/${id}`;
  return apiBasic(data, path, "patch");
};

export const updateOrderProductStatus = (data = null) => {
  let path = `update-order-product-status/`;
  return apiBasic(data, path, "patch");
};

export const printTicket = (payload) => {
  let path = `print-new-order`;
  return apiBasic({ ...payload, ticketType: "kitchen" }, path, "post");
};

export const printInvoice = (payload) => {
  let path = `print-order`;
  return apiBasic(payload, path, "post");
};
